module.exports = __webpack_public_path__ + "img/top-list-left7.5fc7958a.png";